import "./App.css";
import { useState } from "react";

import Sidebar from "./components/Sidebar";
import Header from "./components/Header";

import Dashboard from "./components/Dashboard";
import Reports from "./components/Report";

import CreateInvoice from "./components/CreateInvoice";


function App() {

  const [page, setPage] = useState("dashboard");

  return (

    <div className="app-layout">

      {/* Sidebar */}
      <Sidebar setPage={setPage} />

      {/* Main Content */}
      <div className="main-content">

        {/* Common Header */}
        <Header invoiceType={page} />

        {/* Pages */}
        {page === "dashboard" &&
          <Dashboard />
        }

        {page === "invoice" &&
          <CreateInvoice setPage={setPage} />
        }

       
      
    {page === "reports" &&
          <Reports />
        }

       

      </div>

    </div>
  );
}

export default App;